import { NumberType } from 'libphonenumber-js/core';

export default {
  MOBILE: 'MOBILE' as NumberType,
  PREMIUM_RATE: 'PREMIUM_RATE' as NumberType,
};
